module.exports = __webpack_public_path__ + "img/link-sms.3bd03913.png";